export default "__VITE_ASSET__yZ4TfCvJ__"